import {
  GET_COURSE_UNITS,
  GET_COURSE_UNITS_FAIL,
  GET_COURSE_UNITS_SUCCESS,
  ADD_NEW_COURSE_UNIT,
  ADD_COURSE_UNIT_SUCCESS,
  ADD_COURSE_UNIT_FAIL,
  UPDATE_COURSE_UNIT,
  UPDATE_COURSE_UNIT_SUCCESS,
  UPDATE_COURSE_UNIT_FAIL,
  DELETE_COURSE_UNIT,
  DELETE_COURSE_UNIT_SUCCESS,
  DELETE_COURSE_UNIT_FAIL,
  
} from "./actionTypes";

export const getCourseUnits = () => ({
  type: GET_COURSE_UNITS,
})

export const getCourseUnitsSuccess = courses => ({
  type: GET_COURSE_UNITS_SUCCESS,
  payload: courses,
})

export const getCourseUnitsFail = error => ({
  type: GET_COURSE_UNITS_FAIL,
  payload: error,
})

export const addNewCourseUnit = data => ({
  type: ADD_NEW_COURSE_UNIT,
  payload: data,
})

export const addCourseUnitSuccess = course => ({
  type: ADD_COURSE_UNIT_SUCCESS,
  payload: course,
})

export const addCourseUnitFail = error => ({
  type: ADD_COURSE_UNIT_FAIL,
  payload: error,
})

export const updateCourseUnit = course => ({
  type: UPDATE_COURSE_UNIT,
  payload: course,
})

export const updateCourseUnitSuccess = course => ({
  type: UPDATE_COURSE_UNIT_SUCCESS,
  payload: course,
})

export const updateCourseUnitFail = error => ({
  type: UPDATE_COURSE_UNIT_FAIL,
  payload: error,
})

export const deleteCourseUnit = data => ({
  type: DELETE_COURSE_UNIT,
  payload: data,
})

export const deleteCourseUnitSuccess = data => ({
  type: DELETE_COURSE_UNIT_SUCCESS,
  payload: data,
})

export const deleteCourseUnitFail = error => ({
  type: DELETE_COURSE_UNIT_FAIL,
  payload: error,
})

export const resetCourseUnitLastActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});


